import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

@Directive({
  selector: '[efShadowDelegatedElement]',
  standalone: true,
})
export class EfShadowDelegatedElementDirective implements OnInit, OnDestroy {
  constructor(private readonly elRef: ElementRef) {}

  public ngOnInit(): void {
    if (this.elRef.nativeElement.getRootNode()?.host) {
      return this.elRef.nativeElement.getRootNode().host.parentNode.appendChild(this.elRef.nativeElement);
    }
  }

  public ngOnDestroy(): void {
    if (this.elRef.nativeElement) {
      this.elRef.nativeElement.remove();
    }
  }
}
